// @flow
import React, { type Node } from 'react';
import './ProductTemplate.scss';

type Props = {
  children: Node,
};

const ProductTemplate = ({ children }: Props) => (
  <div className="ProductTemplate">
    <div className="product-area">{children}</div>
  </div>
);

export default ProductTemplate;



// WEBPACK FOOTER //
// ./src/components/product/ProductTemplate/ProductTemplate.js